/**
 * The shared page-helper blurb -- one consistent "what this page does and
 * how to use it" pattern, so a non-expert has a way in before they hit
 * jargon. Every page built so far uses this same component rather than a
 * one-off intro paragraph.
 */
export function PageHelper({ children }: { children: React.ReactNode }) {
  return (
    <div className="page-helper">
      <span className="page-helper-icon">i</span>
      <div className="page-helper-body">{children}</div>
    </div>
  );
}
